export const GET_LABELS = 'GET_LABELS'
export const GET_LABEL = 'GET_LABEL'
export const CREATE_LABELS = 'CREATE_LABELS'
export const UPDATE_LABEL = 'UPDATE_LABEL'
export const DELETE_LABEL = 'DELETE_LABEL'
export const GET_LABEL_TYPES = 'GET_LABEL_TYPES'
